<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green" style="margin-top: 36px;">
                    <v-flex slot="header" class="pa-2">
                        <v-layout row>
                            <span
                                class="subheading font-weight-light mr-3"
                                style="align-self: center"
                                >{{ title }}</span
                            >
                            <v-spacer></v-spacer>
                            <v-menu
                                v-model="datePickerMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                class="date-picker-menu"
                                max-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fromDate"
                                        label="From Date"
                                        class="mx-2 text-black"
                                        readonly
                                        color="green"
                                        style="max-width: 200px; background-color: #fff;"
                                        v-on="on"
                                        hide-details
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    style="color: black !important;"
                                    v-model="fromDate"
                                    @input="onDateChanged"
                                ></v-date-picker>
                            </v-menu>
                            <v-btn
                                small
                                class="mr-2 mb-0"
                                style="background-color: #fff; color: #4caf50 !important; height: 28px;"
                                @click="openNewMessageDialog()"
                            >
                                New Message
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-data-table
                        v-if="!isMobile"
                        :headers="headers"
                        :items="messages"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewMessage(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getStatusIconColor(
                                                        item.status,
                                                    )
                                                "
                                                >{{
                                                    getStatusIcon(item.status)
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.status }}</span>
                                    </v-tooltip>
                                </td>
                                <td
                                    style="min-width: 210px"
                                    class="text-xs-left font-weight-regular"
                                >
                                    {{ item.date }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.type }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.senderName }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.senderPhone }}
                                </td>
                                <td>
                                    <audio
                                        controls
                                        :src="item.originalRecordingUrl"
                                    ></audio>
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    <v-btn
                                        @click.stop="openDeleteMessage(item)"
                                        color="success"
                                        flat
                                        icon
                                        ><v-icon
                                            >mdi-close-circle</v-icon
                                        ></v-btn
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2" v-if="!isMobile">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                    <div v-if="isMobile">
                        <div v-for="(message, index) in getLastMessages()">
                            <div>
                                <v-icon
                                    class="mr-2 "
                                    dark
                                    :color="getStatusIconColor(message.Status)"
                                    >{{ getStatusIcon(message.Status) }}</v-icon
                                >{{ message.Status }}
                            </div>
                            <div class="my-1">{{ message.Date }}</div>
                            <div>
                                {{
                                    message.SenderName +
                                        "        " +
                                        message.SenderPhone
                                }}
                            </div>
                            <audio
                                controls
                                class="mt-2"
                                style="width: 100%;"
                                :src="message.RecordingURL"
                            ></audio>
                            <v-divider
                                class="mb-2 mt-1"
                                v-if="index + 1 < getLastMessages().length"
                                :key="index"
                            ></v-divider>
                        </div>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="newMessageDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">New Message</div>

                <v-btn
                    small
                    class="mr-2 mt-4"
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".mp3"
                    @change="onFilePicked($event)"
                />
                <div v-if="files.length" class="mt-0 ml-2 mb-2">
                    {{ files[0].name }}
                </div>
                <audio
                    class="mt-2 mb-3"
                    v-if="newMessage.recordingURL"
                    controls
                    ref="recordingURL"
                    :src="newMessage.recordingURL"
                ></audio>
                <v-text-field
                    class="mt-2 mb-3"
                    v-model="newMessage.phone"
                    hide-details
                    label="From Phone"
                ></v-text-field>
                <v-text-field
                    class="mt-2 mb-3"
                    v-model="newMessage.type"
                    hide-details
                    label="Option"
                ></v-text-field>
                <v-textarea
                    class="mt-2 mb-3"
                    v-model="newMessage.subject"
                    rows="2"
                    outline
                    hide-details
                    label="Subject"
                ></v-textarea>
                <v-btn
                    class="mt-0 mb-3 py-0"
                    small
                    :disabled="!newMessage.subject"
                    @click="playText(newMessage.subject)"
                    color="info"
                >
                    Play
                </v-btn>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="newMessageDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="sending"
                        @click="sendNewMessage"
                        >Send Message</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewMessageDialog" max-width="900">
            <v-card class="pa-4">
                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    color="success"
                    style="width: 70%;"
                    class="mx-1"
                ></v-progress-linear>

                <div v-if="!loading">
                    <div class="mb-2">Date: {{ clickedMessage.date }}</div>
                    <audio controls :src="clickedMessage.recordingUrl"></audio>
                    <v-divider class="pb-2"></v-divider>
                </div>
                <div
                    class="my-3 mx-1 pa-2 px-3"
                    v-if="!loading"
                    style="border: 2px solid #43a047; width: fit-content;"
                >
                    <div v-for="(info, index) in clickedMessage.listeners">
                        <v-layout row>
                            <div
                                style="width: 220px"
                                class="font-weight-medium"
                            >
                                {{ info.name }}
                            </div>
                            <div style="width: 100px">{{ info.time }}</div>
                            <div>
                                {{ formatDate(info.lastTime) }}
                            </div> </v-layout
                        ><v-divider
                            class="mb-2 mt-1"
                            v-if="index + 1 < clickedMessage.listeners.length"
                        ></v-divider>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                </div>
                <!-- <pre>{{ viewMessageText | pretty }}</pre> -->
                <v-card-actions class="mx-0">
                    <v-btn @click="viewMessageDialog = false" color="#999" dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
            <v-dialog v-model="deleteDialog" max-width="400px">
                <v-card class="pa-3">
                    <div class="headline mb-3">Delete Message</div>

                    <div class="mb-3">Date: {{ messageToDelete.date }}</div>
                    <audio controls :src="messageToDelete.recordingUrl"></audio>

                    <v-card-actions class="mt-2 mr-0 pb-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="deleteDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            :loading="processing"
                            color="success"
                            @click="deleteMessage()"
                        >
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";
import AWS from "aws-sdk";
import { toISOLocal } from "../utils/helpers.js";

export default {
    data() {
        return {
            title: "Wercberger Hotline Messages",
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            processing: false,
            deleteDialog: false,
            messageToDelete: {},

            fromDate: toISOLocal(
                new Date(
                    moment()
                        .subtract(30, "day")
                        .add(1, "day"),
                ),
            ).substr(0, 10),

            isMobile: false,

            headers: [
                { value: "status", text: "Status" },
                { value: "date", text: "Timestamp" },
                { value: "type", text: "Option" },
                { value: "senderName", text: "Sender" },
                { value: "senderPhone", text: "Sender Phone" },
                { value: "originalRecordingUrl", text: "Recording" },
            ],

            messages: [],

            viewMessageDialog: false,
            viewMessageText: "",
            clickedMessage: "",
            datePickerMenu: false,

            newMessageDialog: false,
            uploading: false,
            sending: false,
            loading: false,
            files: [],

            newMessage: {
                recordingURL: "",
                subject: "",
                phone: "13479710707",
                type: "3",
            },

            awsPolly: "",
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    mounted() {
        this.awsPolly = new AWS.Polly({
            accessKeyId: "AKIA3LKZMVJXVMXC6IK6",
            secretAccessKey: "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",
            region: "us-east-1",
        });
    },
    created() {
        this.loadData();
        this.loadContacts();
        this.isMobile = window.innerWidth < 551;
    },
    methods: {
        openDeleteMessage(item) {
            this.messageToDelete = item;
            this.deleteDialog = true;
        },
        getLastMessages() {
            return this.messages.slice(0, 30);
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        async loadData() {
            const fromDate = this.fromDate;
            const response = await this.$http.get(
                "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/api/wercbergerHotline/getMessages?fromDate=" +
                    fromDate,
            );

            this.messages = response.data
                .filter((m) => m.messageNumber == 1 || !m.messageNumber)
                .map((message) => {
                    message.date = moment(message.timestamp).format(
                        "MM/DD/YYYY h:mm:ss A",
                    );
                    message.type = message.type ? message.type : "2";

                    return message;
                });
            this.pagination.totalItems = this.messages.length;
            this.title =
                "Wercberger Hotline Messages (" + this.messages.length + ")";
        },
        onDateChanged() {
            this.loadData();
        },
        groupBy(list, key) {
            return list.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        getDomain() {
            return window.location.host.includes("localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "InProgress":
                case "Queued":
                    return "mdi-progress-upload";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "InProgress":
                case "Queued":
                    return "#42A5F5";
                case "Pending":
                    return "#fdb400";
            }
        },
        async loadContacts() {
            const response = await this.$http.get(
                "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/api/wercbergerHotline/getContacts",
            );

            this.contacts = response.data;
        },
        getCallName(name) {
            if (!this.contacts) return;

            if (!name) return;

            const contact = this.contacts.find((c) => {
                return c.phoneNumber == name.substring(1);
            });

            if (!contact) return;

            return contact.firstName.replace("Phone", "")
                ? contact.firstName.replace("Phone", "") +
                      " " +
                      contact.lastName
                : contact.lastName;
        },
        async viewMessage(message) {
            this.viewMessageDialog = true;
            try {
                this.loading = true;

                const url =
                    "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/api/wercbergerHotline/GetListenersSql?recordingURL=" +
                    message.recordingUrl;

                const response = await this.$http.get(url);

                message.listeners = response.data.listeners.map((listener) => {
                    listener.name = this.getCallName(listener.name)
                        ? this.getCallName(listener.name)
                        : listener.name;

                    return listener;
                });

                this.clickedMessage = message;

                this.viewMessageText = message;
                this.viewMessageDialog = true;

                console.log(JSON.stringify(message, null, 2));

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        openNewMessageDialog() {
            this.newMessageDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            var formData = new FormData();

            formData.append("file", files[0]);

            try {
                const response = await this.$http.post(
                    this.getDomain() + "/api/home/GetUrl?type=greeting",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.newMessage.recordingURL = response.data;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async sendNewMessage() {
            if (!this.$refs.recordingURL || !this.$refs.recordingURL.duration)
                return;

            this.sending = true;

            try {
                await this.$http.post(
                    "https://newhotlinemvc20240918234955.azurewebsites.net/website/SaveMessageAsQueued",
                    {
                        recordingUrl: this.newMessage.recordingURL,
                        callUUID: "callUUID",
                        fromPhone: this.newMessage.phone,
                        recordingDuration: this.$refs.recordingURL.duration,
                        subjectUrl: this.newMessage.type,
                    },
                );

                this.sending = false;
                this.newMessageDialog = false;

                this.newMessage.recordingURL = "";
                this.newMessage.subject = "";
            } catch (e) {
                this.sending = false;
            }
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        formatDate(date) {
            if (!date) return "";

            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async deleteMessage() {
            try {
                this.processing = true;

                await this.$http.post(
                    "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/api/wercbergerHotline/deleteMessages",
                    [this.messageToDelete.originalRecordingUrl],
                );

                this.processing = false;
                this.deleteDialog = false;
                this.loadData();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
.text-black input {
    color: #495057 !important;
}
.v-date-picker-table .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
}
.date-picker-menu button {
    background-color: #fff !important;
}
.v-date-picker-table .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
}
.v-btn__content {
    color: unset;
}
.v-date-picker-header .v-btn__content {
    color: black !important;
}
</style>
